import React, { useState } from "react";
import "./filterItem.scss";
import FilterCheckbox from "../checkboxes/filterCheckbox/FilterCheckbox";

const FilterItem = ({ title, dataList, checkedList, listCheckHandler, setCheckedList }) => {
    const [isCheckedAll, setIsCheckedAll] = useState(false);

    const checkAllHandler = (isChecked) => {
        setIsCheckedAll(isChecked);
        if (isChecked) {
            setCheckedList(dataList.map((filter) => +filter.id));
        } else {
            setCheckedList([]);
        }
    };
    return (
        <div className="filter-item">
            <div className="filter-item__title">{title}</div>
            <div className="filter-item__list">
                <FilterCheckbox
                    lableText={"Обрати все"}
                    id={"1" + title}
                    value={0}
                    onChange={(e) => checkAllHandler(e.target.checked)}
                    isChecked={isCheckedAll}
                />
                {dataList.map((filterItem) => {
                    return (
                        <FilterCheckbox
                            lableText={filterItem.title}
                            id={filterItem.id}
                            value={filterItem.id}
                            onChange={(e) => listCheckHandler(e, checkedList, setCheckedList)}
                            isChecked={checkedList.includes(filterItem.id)}
                            key={filterItem.id}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default FilterItem;
